"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var subscribtion_service_1 = require("../Services/subscribtion.service");
var WickedApiClient_1 = require("../api/WickedApiClient");
var router_1 = require("@angular/router");
var material_1 = require("@angular/material");
var cancelSubscription_component_1 = require("../Dialogs/cancelSubscription/cancelSubscription.component");
var service_service_1 = require("../Services/service.service");
var SubscriptionInformationComponent = /** @class */ (function () {
    function SubscriptionInformationComponent(services, subscribtionService, router, dialog) {
        this.services = services;
        this.subscribtionService = subscribtionService;
        this.router = router;
        this.dialog = dialog;
        this.enableSubscription = false;
        this.subscribtions = [];
        this.loaded = false;
        this._activeSubscription = false;
        this.isSubscriptionInfo = false;
        this.userHasActiveSubscription = false;
        this.enableSubscription = services.enableSubscription;
        if (!this.enableSubscription) {
            this.router.navigate(['']);
        }
    }
    ;
    SubscriptionInformationComponent.prototype.cancelSubscriptionDialog = function (subscribtion) {
        var _this = this;
        var dialogRef = this.dialog.open(cancelSubscription_component_1.CancelSubscriptionComponent, {
            data: subscribtion
        });
        dialogRef.afterClosed().subscribe(function (result) {
            if (result) {
                _this.loadData();
            }
        });
    };
    Object.defineProperty(SubscriptionInformationComponent.prototype, "activeSubscription", {
        get: function () {
            return this._activeSubscription;
        },
        set: function (value) {
            this._activeSubscription = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionInformationComponent.prototype, "getFirstInactive", {
        get: function () {
            var filtered = this.subscribtions.filter(function (v) {
                return v.status != WickedApiClient_1.Status.Active;
            });
            if (filtered) {
                return filtered[0].subscribtionId;
            }
            return "0";
        },
        enumerable: true,
        configurable: true
    });
    SubscriptionInformationComponent.prototype.isActive = function (active) {
        return active == WickedApiClient_1.Status.Active;
    };
    SubscriptionInformationComponent.prototype.loadData = function () {
        var _this = this;
        this._activeSubscription = false;
        this.loaded = false;
        this.subscribtionService.hasUserSubscribtion().then(function (hasSubscription) {
            // if (!hasSubscription) {
            //     this.loaded = true
            // }
            // else {
            _this.subscribtionService.get().then(function (data) {
                _this.subscribtions = data;
                if (_this.subscribtions.length > 0 || _this.services.userService.isAdmin()) {
                    var active = _this.subscribtions.find(function (v) {
                        return v.status == WickedApiClient_1.Status.Active;
                    });
                    if (active != undefined || _this.services.userService.isAdmin()) {
                        _this.userHasActiveSubscription = true;
                    }
                    else {
                        _this.userHasActiveSubscription = false;
                    }
                    _this.activeSubscription = true;
                }
                else {
                    _this.activeSubscription = false;
                }
                _this.loaded = true;
            });
        });
    };
    SubscriptionInformationComponent.prototype.showForm = function () {
        this.isSubscriptionInfo = true;
        this.activeSubscription = false;
    };
    SubscriptionInformationComponent.prototype.subscribeFinished = function () {
        this.activeSubscription = true;
        this.loadData();
    };
    SubscriptionInformationComponent.prototype.ngOnInit = function () {
        this.loadData();
    };
    return SubscriptionInformationComponent;
}());
exports.SubscriptionInformationComponent = SubscriptionInformationComponent;
